import React from 'react';
import { Collapse } from 'antd';

// Один свёрнутый блок на панель — сюда уезжает всё редкое
function AdvancedBlock({ children }) {
  return (
    <Collapse ghost>
      <Collapse.Panel header="Дополнительно" key="advanced">
        {children}
      </Collapse.Panel>
    </Collapse>
  );
}

export default AdvancedBlock;
